module.exports = __webpack_public_path__ + "img/red_bg.7cb2e6cb.png";